import { PREMIUM_VARIABLE_SEED_COLORS } from "../../consts";
import {
  generatePaletteFromSeedColors,
  generateSeedColorsFromVariableSeedColors
} from "../../utils";

export const premiumSeedColors = generateSeedColorsFromVariableSeedColors(
  PREMIUM_VARIABLE_SEED_COLORS
);

export const premiumPalette = generatePaletteFromSeedColors(premiumSeedColors);
